var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3758_55805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 10.2273,
    height: 20,
    fill: "url(#pattern0_3758_55805)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3758_55805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.6665,
    width: 20,
    height: 20,
    fill: "#1D5AE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3758_55805",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3758_55805",
    transform: "scale(0.0222222 0.0113636)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3758_55805",
    width: 45,
    height: 88,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABYCAYAAABh9X7oAAAAAXNSR0IArs4c6QAAAlpJREFUaEPtm/1RAjEQxXcrUCvQDsQKhArECsQK1A6kAulAqECtQKhA6YAStII1j8k5wHBc9i6XM+NmxvEP8vG7N5uXzd4cU6ImIj0iOiMi/Efr11h6ysxTrjEweIiIDImo+DsKHni443V0aBE5JqJ7IhoR0Wkk0M1pxlGhRQSgEyKKpeq+Z44D7dWdEtFVC8ruTtkc2m8wAJ8nAMYSzaA98LzlcIintA8JAKdSuICvr7RT+TVRDMdR2vvvS6IYjga9asmDQ3TQh0fHKtdzjw5juf5GFJGvxBbXLKa9L3+EBF6LfXQxLSJIJ99bBAqZWpfltbgJly4zRNhVNX0+7eIZKedT1cyK3wE7ZGZYaHBTpaaRw+MbNxlmDlF464G6hH5jZtxq1K1L6DEzP6qJXW5q0ErVTOlSwSK7hyltSh/YnP8wPHzKGXI6oYB4o7S2su4LV4TEbV7T5sw8545qFxrQ3b63gMbTXjaZJfHYsUEnUnyQo9JZQp9kpzSjZeYeS2bu5Qa9cIdLPzfombu5j3KDXidZuUE/MPMkN+hBkTDllHtcuFrJZ1ZKw6KRKgAab1jvEuUNjZb5hcYsIoKXl7GS+0ZgJYNR9+sjNNZKa1aIfHrOXAESYoW01WZltUvoZBfbmE5j0IeKNaZ0qvq0KW1Kl+3EyIeLWZ5Z3l+oT5vlmeWZ5ZXvRPNp82nzaa+AXWxDagEbfcw9zD3MPcw9lLbhu5t7mHuYe5h7mHtUK2CpabVGWz2SHS74HPVZCbev+9Z7Qe18qvDA5P6zkeIzau16Rf/X4kVmnQl+AKFiszmBPFSNAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.60973ca6da701cb38f730d08b916e250.svg";
export { ForwardRef as ReactComponent };